export interface IInvalidRow {
    rowIndex: number,
    messages: string[]
}